module.exports = __webpack_public_path__ + "static/prevencion-96b45f8872222ed6998cb0ea20837b42.png";